import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-site-icon',
  templateUrl: './site-icon.component.html',
  styleUrls: ['./site-icon.component.css']
})
export class SiteIconComponent implements OnInit {

  @Input() isOnline = true;
  @Input() isAlarms;

  constructor() { }

  ngOnInit() {
    console.log( "alarms", this.isAlarms)
  }

}
